import { MissionData } from '../blocks/mission'
import template from './templates/Event01.rbxl'
import thumbnail0 from './thumbnails/Event01/mission.png'
import thumbnail1 from './thumbnails/Event01/SpawnLocation.png'
import thumbnail2 from './thumbnails/Event01/BlueBlock.png'
import thumbnail3 from './thumbnails/Event01/GreenBlock.png'
import thumbnail4 from './thumbnails/Event01/WhiteBlock.png'
import thumbnail5 from './thumbnails/Event01/YellowBlock.png'
import thumbnail6 from './thumbnails/Event01/Ball.png'

const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  template,
  thumbnail: thumbnail0,
  title: 'おちるな！マグマチャレンジ！',
  chapters: [],
  objects: [
    {
      name: '①スタートちてん',
      thumbnail: thumbnail1,
      sound: true,
    },
    {
      name: '②あおいブロック',
      thumbnail: thumbnail2,
      sound: true,
    },
    {
      name: '③みどりのブロック',
      thumbnail: thumbnail3,
      sound: true,
    },
    {
      name: '④しろいブロック',
      thumbnail: thumbnail4,
      sound: true,
    },
    {
      name: '⑤きいろのブロック',
      thumbnail: thumbnail5,
      sound: true,
    },
    {
      name: '⑥ボール',
      thumbnail: thumbnail6,
      sound: true,
    },
  ],
}

export default mission
